import { getAuth, connectAuthEmulator } from 'firebase/auth';
import app from './config';

const auth = getAuth(app);

// Opt-in, nur wenn explizit gesetzt (z.B. `REACT_APP_USE_EMULATORS=true npm start`) -
// Standardverhalten (Produktion) bleibt unverändert. Siehe docs/firebase-setup.md.
if (process.env.REACT_APP_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
}

export default auth;
